import { ConsumptionType } from '../../../../../services/analysis.service';
import { ConsumptionTypeAdditionalData, ConsumptionTypeInterface } from './consumption-type.interface';
import { SolarCalculatorRequest } from '../../../../models/analysis/solar-calculator-request';

export class HourlyConsumptionType implements ConsumptionTypeInterface {
  getConsumptionType(): ConsumptionType {
    return ConsumptionType.HOURLY;
  }

  setRequestData(request: SolarCalculatorRequest, formValue: any, additionalData: ConsumptionTypeAdditionalData) {
    request.consumptionHourly = additionalData.consumptionFileData;
  }

}
